import { roleWisePermissions } from './RoleAndPermissions'

const HasPermission = (permission) => {
  let user_role = localStorage.getItem('user_role')
  let allPermissions = roleWisePermissions(user_role) || []

  return allPermissions.includes(permission) ? true : false
}

export default HasPermission
